import { type AppContext } from "@/types";
import NodeSequence from "@/shared/ui/components/node-sequence";
import Skeleton, { SkeletonShape } from "@/shared/ui/components/skeleton";

const LoadingCheckout = ({ ctx }: { ctx: AppContext }) => (
  <div className="px-4 py-4">
    <NodeSequence
      timeout={2000}
      nodes={[
        ctx.t("loading.checking_details"),
        ctx.t("loading.pulling_credit"),
        ctx.t("loading.reviewing_income"),
        ctx.t("loading.finalising_plans"),
      ].map((text) => (
        <div className="text-[24px] font-semibold text-gray-900">{text}</div>
      ))}
    />

    <div className="bg-gray-100 p-6 mt-5" style={{ borderRadius: "20px" }}>
      <div className="space-y-4">
        {/* Header with avatar and text */}
        <div className="flex items-center space-x-3">
          <Skeleton shape={SkeletonShape.CIRCLE} width={40} height={40} />
          <div className="flex-1">
            <Skeleton
              shape={SkeletonShape.LINES}
              lineCount={1}
              lineHeight={16}
              className="w-3/4"
            />
          </div>
        </div>

        {/* Content lines */}
        <div className="space-y-2">
          <Skeleton shape={SkeletonShape.LINES} lineCount={2} lineHeight={14} />
        </div>

        {/* Footer with action buttons */}
        <div className="flex justify-between items-center pt-2">
          <Skeleton
            shape={SkeletonShape.LINES}
            lineCount={1}
            lineHeight={16}
            className="w-20"
          />
          <Skeleton
            shape={SkeletonShape.LINES}
            lineCount={1}
            lineHeight={16}
            className="w-16"
          />
        </div>
      </div>
    </div>
  </div>
);

export default LoadingCheckout;
